import type SortBy from 'mini-common-schema/lib/schema/SortBy';
import { type SortColumn } from 'mini-common-schema/lib/schema/SortBy';
import type SortDirection from 'owa-service/lib/contract/SortDirection';

export const DEFAULT_SORT_DIR: SortDirection = 'Descending';
export const DEFAULT_SORT_COLUMN: SortColumn = 0;

/**
 * Gets the default sortBy property
 * @returns returns the default sortBy property
 */
export default function getDefaultSortBy(): SortBy {
    return {
        sortColumn: DEFAULT_SORT_COLUMN,
        sortDirection: DEFAULT_SORT_DIR,
    };
}
